import { Flex, Text } from '@mantine/core'

import CoinIcon from '@/components/CoinIcon'
import useCoinPriceChange from '@/hooks/business/useCoinPriceChange'
import { CryptoBasketCoin } from '@/types/invest'

import styles from './styles.module.css'

export default function CoinItem({ name, symbol }: Pick<CryptoBasketCoin, 'name' | 'symbol'>) {
  const { coinMarket, percentage, changeColor, changeSymbol } = useCoinPriceChange(name)
  if (!coinMarket) return null

  return (
    <Flex className={styles.yieldPeriodContainer}>
      <Flex gap={8}>
        <CoinIcon coin={coinMarket} size={16} />
        <Text variant="subtitle">{symbol}</Text>
      </Flex>
      <Text variant="subtitle" c={changeColor}>{`${changeSymbol}${percentage}`}</Text>
    </Flex>
  )
}
